import React from 'react'
import { Heading } from '@myxplor/ui'
import { FormSubmit } from '@myxplor/forms'
import { GovActionContentWrapper } from '../../../ui/gov-actions'

export const CreateCaseClaimDone = ({ refresh }) => (
  <GovActionContentWrapper>
    <form
      onSubmit={e => {
        e.preventDefault()
        return refresh()
      }}>
      <fieldset>
        <Heading small compact>
          Success!
        </Heading>
        Your ISS Case Claim was submitted
      </fieldset>

      <FormSubmit>Done</FormSubmit>
    </form>
  </GovActionContentWrapper>
)



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/create-claim-done.jsx